import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';

const StyledSectionWrapper = styled.div`
  padding-top: ${tokens.spacing.section};
  padding-bottom: ${tokens.spacing.section};
`;

export function SectionWrapper({ children, ...props }) {
  return <StyledSectionWrapper {...props}>{children}</StyledSectionWrapper>;
}

export default SectionWrapper;
